import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { Splash } from '@/components/ui/Splash';
import { CHANNEL_VIA_PARAMS } from '@/features/msg-channels/common/msg-channels.types';
import { subscriptionApis } from '@/features/subscription';
import { CheckoutPlanEnum } from '@/features/subscription/subscription.types';

export const Route = createFileRoute('/_channels/channels/upgrade')({
  validateSearch: z
    .object({
      plan: CheckoutPlanEnum.optional().catch(undefined),
      via: z.enum(CHANNEL_VIA_PARAMS).optional().catch(undefined),
    })
    .passthrough().parse,
  loaderDeps: ({ search }) => ({ plan: search.plan, via: search.via }),
  async loader({ deps }) {
    if (!deps.plan) return;
    await subscriptionApis.startPlanCheckout(deps.plan, 'channels');
    throw redirect({
      to: '/channels/upgrade',
      search: { via: deps.via },
      replace: true,
    });
  },
  pendingComponent: () => (
    <div className="fixed inset-0 z-50 bg-background">
      <Splash reason="upgrade-checkout" />
    </div>
  ),
  pendingMs: 0,
});
